import Repository from "./Repository";

const resource = "";
export default {
  /**
   * 市町村検索結果取得
   * @param {*} searchWord 検索ワード
   */
  getAreaSearchResults(searchWord) {
    const encSearchWord = encodeURIComponent(searchWord);
    return Repository.get(`${resource}/map/areaSearch/` + encSearchWord);
  },
};
